import { gql } from '@apollo/client';

export const getBusinessPartnersPlansList = gql`
  query getBusinessPartnersPlansList(
    $currentPage: Int!
    $currentPageSize: Int!
    $selectedBusinessUserID: String
    $selectedBusinessPartnerID: [String]
    $selectedLineID: [String]
    $selectedPlanID: [String]
    $Attribute: String!
    $Descending: Boolean!
    $keywordSearch: String
  ) {
    SalesforceManagement {
      queries {
        getAssignedBPPlanList(
          pagination: { pageNumber: $currentPage, pageSize: $currentPageSize }
          selectedBusinessUserID: $selectedBusinessUserID
          selectedBusinessPartnerID: $selectedBusinessPartnerID
          selectedLineID: $selectedLineID
          selectedPlanID: $selectedPlanID
          OrderBy: { Attribute: $Attribute, Descending: $Descending }
          KeywordSearch: $keywordSearch
        ) {
          paging {
            pageSize
            pageNumber
            totalCount
          }
          items {
            businessPartner_Id
            businessPartner_PersonID {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    FullName
                  }
                }
              }
            }
            salesforceManagement_AssignedBPPlan_Id
            salesforceManagement_AssignedBPPlan_BusinessPartnerID {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    Code
                  }
                }
              }
            }
            salesforceManagement_AssignedBPPlan_BusinessUserID {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    Code
                  }
                }
              }
            }
            salesforceManagement_AssignedBPPlan_PlanID {
              id
              views {
                PlanConfigManagement_all {
                  properties {
                    Name
                    ExternalCode
                  }
                }
              }
            }
            salesforceManagement_AssignedBPPlan_BusinessPartnerLineID {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    Status
                  }
                }
              }
            }
            salesforceManagement_AssignedBPPlan_BusinessPartnerPlanID {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    Status
                  }
                }
              }
            }
            salesforceManagement_AssignedBPPlan_LineID {
              id
              views {
                PlanConfigManagement_all {
                  properties {
                    Name
                    ExternalCode
                  }
                }
              }
            }
            salesforceManagement_AssignedBPPlan_Status
          }
        }
      }
    }
  }
`;

export const getAssignedBPLineListWithoutPagination = gql`
  query getAssignedBPLineListWithoutPagination(
    $selectedBusinessUserID: String!
  ) {
    SalesforceManagement {
      queries {
        getAssignedBPListWithoutPagination(
          selectedBusinessUserID: $selectedBusinessUserID
        ) {
          salesforceManagement_AssignedBP_BusinessPartnerID {
            id
            views {
              SalesforceManagement_all {
                properties {
                  PersonID {
                    views {
                      SalesforceManagement_all {
                        properties {
                          FullName
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        getDistinctAssignedBPLineListWithoutPagination(
          selectedBusinessUserID: $selectedBusinessUserID
        ) {
          salesforceManagement_AssignedBPPlan_LineID {
            id
            views {
              PlanConfigManagement_all {
                properties {
                  Name
                  ExternalCode
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getAssignedPlanListWithoutPagination = gql`
  query getAssignedPlanListWithoutPagination(
    $selectedBusinessUserID: String!
    $selectedLineID: [String]
  ) {
    SalesforceManagement {
      queries {
        getDistinctAssignedBPPlanListWithoutPagination(
          selectedBusinessUserID: $selectedBusinessUserID
          selectedLineID: $selectedLineID
        ) {
          salesforceManagement_AssignedBPPlan_PlanID {
            id
            views {
              PlanConfigManagement_all {
                properties {
                  Name
                  ExternalCode
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const activateAssignedBPPlan = gql`
  mutation activateAssignedBPPlan(
    $businessUserID: String!
    $selectedAssignedBPPlanIds: [String!]!
  ) {
    salesforceManagement {
      actions {
        activateAssignedBPPlan(
          businessUserID: $businessUserID
          selectedAssignedBPPlanIds: $selectedAssignedBPPlanIds
        )
      }
    }
  }
`;

export const deactivateAssignedBPPlan = gql`
  mutation deactivateAssignedBPPlan(
    $businessUserID: String!
    $selectedAssignedBPPlanIds: [String!]!
  ) {
    salesforceManagement {
      actions {
        deactivateAssignedBPPlan(
          businessUserID: $businessUserID
          selectedAssignedBPPlanIds: $selectedAssignedBPPlanIds
        )
      }
    }
  }
`;
